/**
* @desc: 弹窗·收款人 添加/修改/删除/重新打款/撤回打款
* @author: zengtiansheng
* @update: 2018/3/17
*/
<style lang="less" scoped>
.dialog-title {
  margin-left: 10px;
}

.dialog-content {
  margin-left: 10px;
  color: #9c9c9c;
  font-size: 14px;
}

.content-footer {
  margin-left: 10px;
  text-align: right;
}
</style>
<template>
  <el-dialog v-show="dialogVisible" :visible.sync="dialogVisibleShow" width="520px">
    <div slot="title" class="dialog-title">
      <p style="font-size: 20px" v-if="dialogShowType==='_ADD'">新增收款人</p>
      <p style="font-size: 20px" v-if="dialogShowType==='_REVISE'">修改收款人</p>
      <p style="font-size: 20px" v-if="dialogShowType==='_DELETE'">删除收款人</p>
      <p style="font-size: 20px" v-if="dialogShowType==='_PAYFOR'">重新打款</p>
      <p style="font-size: 20px" v-if="dialogShowType==='_RECALL'">撤回打款</p>
      <span style="font-size: 12px;color: #9C9C9C" v-if="dialogShowType==='_PAYFOR'">
        请填写收款人真实姓名或手机号码重新打款
      </span>
    </div>
    <div class="dialog-content">
      <div class="content-form">
        <el-form :model="formData" :rules="formRules" label-width="80px" label-position="right" ref="formRef">
          <el-form-item prop="name">
            <span style="color: #9C9C9C" slot="label">姓名</span>
            <el-input v-model="formData.name" style="width: 245px" placeholder="请填写姓名" :maxlength="32" :disabled="isInputDisabled"></el-input>
          </el-form-item>
          <el-form-item prop="mobile">
            <span style="color: #9C9C9C" slot="label">手机号</span>
            <el-input v-model="formData.mobile" style="width: 245px" placeholder="请填写手机号" :maxlength="11" :disabled="isInputDisabled" onkeypress="return (event.keyCode>=48&&event.keyCode<=57)"></el-input>
          </el-form-item>
          <el-form-item prop="payMoney">
            <span style="color: #9C9C9C" slot="label">发放金额</span>
            <el-input v-model.number="formData.payMoney" placeholder="请填写发放金额" onkeypress="return (/^\d+(\.\d{1,1})?$/.test(event.path[0].value-0))" type="number" :disabled="isInputDisabled || dialogShowType === '_PAYFOR'" style="width: 245px"></el-input>
          </el-form-item>
          <el-form-item prop="remark">
            <span style="color: #9C9C9C" slot="label">备注</span>
            <el-input v-model="formData.remark" style="width: 245px" placeholder="请填写备注（可不填）" :disabled="isInputDisabled"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content-footer" v-if="dialogShowType === '_PAYFOR'">
      <el-button type="primary" style="width: 96px" :loading="loadingPayFlag" @click="btnCreateSingleOrderClick">支付</el-button>
      <el-button style="width: 96px" @click="btnCloseDialogClick">取消</el-button>
    </div>
    <div class="content-footer" v-else-if="dialogShowType === '_RECALL'">
      <el-button type="primary" style="width: 96px" :loading="loadingPayFlag" @click="btnRecallClick">确认撤回</el-button>
      <el-button style="width: 96px" @click="btnCloseDialogClick">取消</el-button>
    </div>
    <div class="content-footer" v-else>
      <el-button type="primary" @click="btnCloseDialogClick" plain>取消</el-button>
      <el-button type="primary" style="width: 96px" :loading="loadingFlag" @click="btnSubmitClick">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import API from '../API'
import { dialogMixin } from 'src/mixin/index'
import { validateMoney, validateNunber } from 'src/libs/formRules'

export default {
  mixins: [dialogMixin],
  props: {
    refreshData: {
      type: Function,
      default: null
    },
    dialogData: {
      type: Object,
      default: {}
    },
    dialogShowType: {
      // 添加：_ADD, 修改：_REVISE,删除：_DELETE, _PAYFOR: 打款, _RECALL: 撤回打款
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formData: {
        name: '', //姓名
        mobile: '', // 手机号
        payMoney: '', // 发放金额
        remark: '', // 备注
        projectAssistantRecordId: '', //项目列表  item id
        projectAssistantId: '' // 项目id
      },
      formRules: {
        payMoney: [
          {
            type: 'number',
            required: true,
            message: '请填写金额',
            trigger: 'blur'
          },
          validateMoney
        ],
        mobile: [
          { required: true, message: '请填写手机号', trigger: 'blur' },
          validateNunber({ message: '请正确填写手机号', len: 11 })
        ],
        remark: [
          {
            min: 0,
            max: 100,
            message: '备注内容限定100个字符',
            trigger: 'change'
          }
        ],
        name: [
          { required: true, message: '请填写姓名', trigger: 'blur' },
          { min: 0, max: 32, message: '姓名不得过长', trigger: 'blur' }
        ]
      },
      loadingFlag: false,
      loadingPayFlag: false
    }
  },
  watch: {
    dialogData() {
      this.$nextTick(function() {
        this.$refs['formRef'].resetFields()
        const {
          userName,
          userMobile,
          payMoney,
          remark,
          projectAssistantRecordId,
          projectAssistantId,
          cancelPay
        } = this.dialogData
        this.formData = {
          name: userName, //姓名
          mobile: userMobile, // 手机号
          payMoney: parseFloat(payMoney), // 发放金额
          remark, // 备注
          projectAssistantRecordId, //项目列表  item id
          projectAssistantId, // 项目id
          cancelPay // 是否可撤回打款
        }
      })
    }
  },
  computed: {
    isInputDisabled() {
      if (
        this.dialogShowType === '_DELETE' ||
        this.dialogShowType === '_RECALL'
      ) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    ...mapActions('wallet', {
      SET_WALLET: 'SET_WALLET'
    }),
    btnSubmitClick() {
      switch (this.dialogShowType) {
        case '_ADD':
          this.validateForm(
            'formRef',
            this.submit.bind(
              this,
              API.addOneProjectRecord,
              this.formData,
              '收款人添加成功'
            )
          )
          break
        case '_REVISE':
          this.validateForm(
            'formRef',
            this.submit.bind(
              this,
              API.updateProjectRecord,
              this.formData,
              '收款人修改成功'
            )
          )
          break
        case '_DELETE':
          const { projectAssistantRecordId } = this.formData
          this.submit(
            API.delOneProjectRecord,
            { projectAssistantRecordId },
            '收款人删除成功'
          )
          break
        default:
          return false
      }
    },
    async submit(api, formData, msg) {
      try {
        this.loadingFlag = true
        const res = await this.$axios(api, formData)
        this.loadingFlag = false
        if (res.success) {
          this.$message({ type: 'success', message: msg })
          this.$emit('update:dialogVisible', false)
          if (this.refreshData) {
            this.refreshData()
          }
        } else {
          this.$message({ type: 'warning', message: res.msg })
        }
      } catch (err) {
        console.log(err)
        this.loadingFlag = false
        this.$message({ type: 'error', message: res.msg })
      }
    },
    // 撤回支付
    async btnRecallClick() {
      const { projectAssistantRecordId, cancelPay } = this.formData
      if (cancelPay === 0) {
        this.$message({ type: 'warning', message: '该项目不可撤回打款' })
        return
      }
      this.loadingPayFlag = true
      const res = await this.$axios(API.recordWithdraw, {
        projectAssistantRecordId
      })
      this.loadingPayFlag = false
      if (res.success) {
        this.$emit('update:dialogVisible', false)
        this.SET_WALLET() //更新钱包
        this.refreshData()
      }
    },
    // 重新支付
    async btnCreateSingleOrderClick() {
      this.loadingPayFlag = true
      const res = await this.$axios(API.createSingleOrder, this.formData)
      this.loadingPayFlag = false
      if (res.success) {
        this.$emit('update:dialogVisible', false)
        this.$router.push({
          path: '/payment/payFor',
          query: {
            redirectUri:
              '/payment/detailProject?projectAssistantId=' +
              this.dialogData.projectAssostantId,
            tradeOrderId: res.data.tradeOrderId
          }
        })
      }
    },
    btnCloseDialogClick() {
      this.$emit('update:dialogVisible', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/payment/modules/dialogCRUDPayee.vue